<template>
<basepage title="Coper Parametreler" :status="status">
  <template slot="toolbar">
    <v-btn :disabled="status.loading" flat @click="ParametreSave()">{{$t("save_button")}}</v-btn>
  </template>

  <v-tabs>
    <v-tab v-for="tab in kategori" :key="tab.Id" :href="`#tab-${tab.Id}`">
      {{ tab.Title }}
    </v-tab>

    <v-tab-item v-for="tab in kategori" :key="tab.Id" :value="'tab-' + tab.Id">

      <div v-for="i in tab.Parametreler" :key="i.Title">

        <div v-if="i.DataType === 0">
          <v-text-field :label="i.Title" v-model="i.Value" hide-details> </v-text-field>
        </div>

        <div v-else-if="i.DataType === 1">
          <v-text-field type=number :label="i.Title" v-model="i.Value" hide-details> </v-text-field>
        </div>

        <div v-else-if="i.DataType === 2">
          <v-checkbox v-model="i.Value" class="ma-2" :label="i.Title"></v-checkbox>
        </div>

        <div v-else-if="i.DataType === 3">

          <v-select v-model="i.Value" :items="i.EnumValueList" item-text="Text" item-value="Value" :label="i.Title"></v-select>

        </div>

        <div v-else-if="i.DataType === '1000'">

          <v-text-field type="date" :label="i.Title" v-model="profil.valueDate" hide-details> </v-text-field>

        </div>
        <div v-else-if="i.DataType === 4">
          <v-text-field type=number step=0.0001 :label="i.Title" v-model="i.Value" hide-details> </v-text-field>
        </div>

        <div v-else-if="i.DataType === 5">
          <geneltipara :tip="i.GenelTipAra_Tip" hide-details :label="i.Title" v-model="i.GenelTipAra_Value"></geneltipara>
        </div>


        <div v-else>
          {{ $t('DataType-Undefined') }} : {{i.DataType}}
        </div>

      </div>

    </v-tab-item>

  </v-tabs>

  <!--
  <v-text-field v-for="(value, key) in ayar" :label="key" :key="key.id" v-model="ayar[key]" hide-details> </v-text-field>
-->

</basepage>
</template>

<script>
import basepage from "@/components/app/coper/comp/basepage.vue";
import geneltipara from "@/components/app/coper/comp/geneltipara.vue";

import tool from "../../tools";

export default {
  components: {
    basepage,
  geneltipara,
  },
  data() {
    return {
      status: tool.NewSatatus(),
      kategori: null,
    };
  },
  methods: {

    ParametreSave() {
      let params = {
        Value: this.kategori
      }
      this.status.loading = true;

      tool.http_post(this, 'ParametreSave', params).then(
        response => {
          this.status.loading = false;
          if (response.body.Status == true) {
            this.kategori = response.body.data;
          } else {
            this.status.text = response.body.ErrorList[0];
            this.status.show = true;
          }
        },
        response => {
          this.status = tool.responseToStatus(response);
        }
      );
    },

    ParametreLoad() {
      let params = {}
      this.status.loading = true;
      tool.http_post(this, 'ParametreLoad', params).then(
        response => {
          this.status.loading = false;
          if (response.body.Status == true) {
            this.kategori = response.body.data;
          } else {
            this.status.text = response.body.ErrorList[0];
            this.status.show = true;
          }
        },
        response => {
          this.status = tool.responseToStatus(response);
        }
      );
    },
  },
  beforeMount: beforeMount,
};

function beforeMount() {

  this.ParametreLoad();

}
</script>
